import { filterSelectTriggerClassName } from "@/components/dashboard/active-filters-bar";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import type { JurisdictionOption } from "@/types";

interface JurisdictionFilterProps {
  selectedJurisdictions: string[];
  onSelectedJurisdictionsChange: (jurisdictions: string[]) => void;
  jurisdictionOptions: JurisdictionOption[];
}

export function JurisdictionFilter({
  selectedJurisdictions,
  onSelectedJurisdictionsChange,
  jurisdictionOptions,
}: JurisdictionFilterProps) {
  return (
    <div className="w-full shrink-0 md:w-64 md:max-w-full">
      <Label htmlFor="jurisdiction-filter" className="mb-2 block font-bold">
        Filter by Jurisdiction
      </Label>
      <Select
        options={jurisdictionOptions}
        value={selectedJurisdictions}
        onValueChange={onSelectedJurisdictionsChange}
        multiple
        showBadges={false}
        placeholder="Select jurisdictions"
        searchPlaceholder="Search jurisdictions..."
        emptyMessage="No jurisdiction found."
        buttonVariant="default"
        className={filterSelectTriggerClassName(
          selectedJurisdictions.length > 0,
        )}
      />
    </div>
  );
}
